import compRoleLogin from "./components/compRoleLogin.vue";
import { getGameServerMap } from "@/utils/dictionary";
import timeDateOptions from "../../components/timeList/timeDateOptions.vue";
import serverList from "../../components/serverList/serverOptions.vue";
export default {
  components: {
    compRoleLogin: compRoleLogin,
    timeDateOptions: timeDateOptions,
    serverList: serverList
  },
  name: "loginLog",
  data: function data() {
    return {
      serverList: {},
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      searchInfo: {
        server_id: []
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      getGameServerMap().then(function (res) {
        _this.serverList = res;
      });
    },
    queryEvent: function queryEvent(e) {
      this.searchInfo.sdate = this.timedata[0];
      this.searchInfo.edate = this.timedata[1];
      if (e == "search") {
        this.$refs.myChild.goMethod("1", this.searchInfo);
      } else {
        this.$refs.myChild.goMethod("2", this.searchInfo);
      }
    }
  }
};